/* Maison Felzo — mesure d'audience simple : pièces vues, temps passé, provenance, paniers, recherches.
   Anonyme : un identifiant aléatoire par appareil (stocké sur l'appareil, aucun cookie). Le lien avec le compte du client
   n'est fait que s'il est connecté ET l'a accepté. L'équipe n'est pas comptée (lien d'exclusion + adresses exclues). */
(function () {
  var T = window.MF_TRACK
  if (!T || !T.api) return
  var LS = null
  try { LS = window.localStorage } catch (e) {}
  function get(k) { try { return LS ? LS.getItem(k) : null } catch (e) { return null } }
  function set(k, v) { try { if (LS) LS.setItem(k, v) } catch (e) {} }
  function url(action) { return T.api + (T.api.indexOf('?') > -1 ? '&' : '?') + 'action=' + action }
  function rnd(n) { var a = new Uint8Array(n / 2), s = ''; (window.crypto || window.msCrypto).getRandomValues(a); for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2); return s }

  // lien d'exclusion de l'équipe : ?mf_team=CLE sur n'importe quelle page de la boutique (?mf_team=off pour annuler)
  var m = /[?&]mf_team=([^&#]+)/.exec(location.search)
  if (m) {
    if (m[1] === 'off') { set('mf_team', '0') }
    else { fetch(url('site_team_check') + '&k=' + encodeURIComponent(m[1]), { cache: 'no-store' }).then(function (r) { return r.json() }).then(function (d) { if (d && d.ok) set('mf_team', '1') }).catch(function () {}) }
    return
  }
  if (get('mf_team') === '1') return
  if (navigator.doNotTrack === '1') return

  var vid = get('mf_vid')
  if (!vid || !/^[a-f0-9]{32}$/.test(vid)) { vid = rnd(32); set('mf_vid', vid) }
  var sid = null, src = ''
  try { sid = sessionStorage.getItem('mf_sid'); src = sessionStorage.getItem('mf_src') || '' } catch (e) {}
  var first = !sid
  if (!sid) { sid = rnd(32); try { sessionStorage.setItem('mf_sid', sid) } catch (e) {} }

  function host(u) { try { return new URL(u).hostname.replace(/^www\./, '') } catch (e) { return '' } }
  if (first) {
    var q = new URLSearchParams(location.search), utm = (q.get('utm_source') || '').toLowerCase().replace(/[^a-z0-9._-]/g, '')
    var rh = host(document.referrer), own = location.hostname.replace(/^www\./, '')
    if (utm) src = utm
    else if (!rh || rh === own || /maisonfelzo|myshopify|shopify\.com$/.test(rh)) src = ''
    else if (/instagram/.test(rh)) src = 'instagram'
    else if (/tiktok/.test(rh)) src = 'tiktok'
    else if (/google\./.test(rh)) src = 'google'
    else if (/facebook|fb\.com|messenger/.test(rh)) src = 'facebook'
    else if (/bing\./.test(rh)) src = 'bing'
    else if (/pinterest/.test(rh)) src = 'pinterest'
    else if (/whatnot/.test(rh)) src = 'whatnot'
    else if (/ebay\./.test(rh)) src = 'ebay'
    else if (/vinted/.test(rh)) src = 'vinted'
    else src = rh.replace(/[^a-z0-9._-]/g, '').slice(0, 40)
    try { sessionStorage.setItem('mf_src', src) } catch (e) {}
  }

  var logged = !!(T.c && T.e && T.t) && get('mf_link') === '1'
  function send(events) {
    var p = { v: vid, s: sid, ev: events }
    if (logged) { p.c = T.c; p.e = T.e; p.t = T.t }
    var body = JSON.stringify(p)
    try { if (navigator.sendBeacon && navigator.sendBeacon(url('site_track'), new Blob([body], { type: 'text/plain' }))) return } catch (e) {}
    try { fetch(url('site_track'), { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {}) } catch (e) {}
  }
  function prod() { return { i: T.pid || '', k: T.sku || '', h: T.handle || '', n: T.title || '' } }
  function merge(a, b) { for (var k in b) a[k] = b[k]; return a }

  var pv = { t: 'pv', p: T.page || 'other', u: location.pathname.slice(0, 180), r: src }
  if (T.page === 'product') merge(pv, prod())
  send([pv])

  if (T.page === 'search' && T.q) send([{ t: 'search', p: 'search', q: String(T.q).slice(0, 80) }])

  // temps réellement passé sur la page (onglet visible), envoyé quand la personne quitte
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0, total = 0, sent = false
  function flush() {
    if (visibleSince) { total += Date.now() - visibleSince; visibleSince = 0 }
    var s = Math.round(total / 1000)
    if (sent || s < 2) return
    sent = true
    var e = { t: 'dur', p: T.page || 'other', d: Math.min(s, 1800) }
    if (T.page === 'product') merge(e, prod())
    send([e])
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush()
    else { visibleSince = Date.now(); sent = false; total = 0 }
  })
  window.addEventListener('pagehide', flush)

  // ajout au panier depuis une fiche pièce
  if (T.page === 'product') {
    document.addEventListener('submit', function (ev) {
      var f = ev.target
      if (f && f.action && f.action.indexOf('/cart/add') > -1) { var e = { t: 'atc', p: 'product' }; send([merge(e, prod())]) }
    }, true)
  }

  // accord du client connecté pour relier son activité à son compte (une seule fois)
  if (T.c && T.e && T.t && get('mf_link') === null) {
    var bar = document.createElement('div')
    bar.className = 'mf-consent'
    bar.setAttribute('role', 'dialog')
    bar.setAttribute('aria-label', 'Personnalisation')
    bar.innerHTML = '<p>Pour vous proposer des pièces qui vous correspondent, nous pouvons relier les pièces que vous consultez à votre compte. Vous pouvez changer d’avis à tout moment en nous écrivant.</p><div><button type="button" data-y>Accepter</button><button type="button" data-n>Non merci</button></div>'
    function close(v) { set('mf_link', v); logged = v === '1'; bar.remove() }
    bar.querySelector('[data-y]').addEventListener('click', function () { close('1') })
    bar.querySelector('[data-n]').addEventListener('click', function () { close('0') })
    document.body.appendChild(bar)
  }
})()
